export const getTableFormat = (len: number, value: string | number) =>
    Array(len).fill(value)

/**
 * If the actual column count exceeds the explicit widths array,
 * extend with `defaultWidth` so new backend columns render gracefully
 * without requiring a front-end deploy.
 */
export const extendWidthsForExtraColumns = (
    widths: number[],
    columnCount: number,
    defaultWidth: number,
): number[] => {
    if (columnCount <= widths.length) return widths
    return [...widths, ...Array(columnCount - widths.length).fill(defaultWidth)]
}
